import VoucherGroups from './StaticVoucherGroups'

export default VoucherGroups;


// WEBPACK FOOTER //
// ./src/components/Query/StaticVoucherGroups/index.ts